import { render } from "./LearnLink.vue?vue&type=template&id=639a47c0&scoped=true"
import script from "./LearnLink.vue?vue&type=script&lang=js"
export * from "./LearnLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639a47c0"]])

export default __exports__